<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h5>
        Select Company
      </h5>
    </div>

    <div class="panel-body">
      <form @submit.prevent="load">
        <div class="row">
          <div class="col-xs-20">
            <div class="form-group">
              <input class="form-control input-sm" type="text" v-model="search">
            </div>
          </div>

          <div class="col-xs-4">
            <button type="submit" class="btn btn-block btn-sm btn-black">
              <i class="fa fa-search"/> Search
            </button>
          </div>
        </div>
      </form>

      <table class="table table-condensed table-striped">
        <thead>
        <tr>
          <th class="col-xs-7">
            Company Name
          </th>

          <th class="col-xs-7">
            Company CVR
          </th>

          <th class="col-xs-7">
            Portal Alias
          </th>

          <th class="col-xs-3"></th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="portalCompany in portalCompanies" class="success">
          <td>
            {{ portalCompany.attributes.company_name }}
          </td>

          <td>
            {{ portalCompany.attributes.company_cvr }}
          </td>

          <td>
            {{ portalCompany.attributes.name }}
          </td>

          <td class="text-right">
            <router-link
                class="btn btn-xs btn-black"
                :to="'create/'+portalCompany.id"
            >
              <i class="fa fa-check"/> Select
            </router-link>
          </td>
        </tr>

        <tr v-for="company in companies">
          <td>
            {{ company.name }}
          </td>

          <td>
            {{ company.cvr }}
          </td>

          <td>
            {{ company.portal_company_name }}

            <span v-if="!company.portal_company_id" class="label label-info">
              Not on portal
            </span>
          </td>

          <td class="text-right">
            <router-link
                v-if="company.portal_company_id"
                class="btn btn-xs btn-black"
                :to="'create/'+company.portal_company_id"
            >
              <i class="fa fa-check"/> Select
            </router-link>

            <button
                v-else
                type="button"
                class="btn btn-xs btn-black"
                @click="store(company)"
            >
              <i class="fa fa-check"/> Select
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import http from '@/http'

export default {
  props: {
    portal: {
      required: true
    }
  },

  data() {
    return {
      search: null,

      portalCompanies: null,
      companies: [],
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/portal-companies', {'filter[portal_id]': this.portal.id, 'filter[is_editorial]': '1'}),
        http.get('/api/v2/companies', {'filter[search]': this.search, page_size: 10}),
      ]).then(responses => {
        this.portalCompanies = responses[0].data.data

        this.companies = responses[1].data.data.map(company => this.mapCompany(company))
      })
    },

    mapCompany(company) {
      return {
        id: company.id,
        name: company.attributes.name,
        cvr: company.attributes.cvr,
        portal_company_id: company.attributes.portal_companies.find(portalCompany => portalCompany.portal_id === this.portal.id)?.id,
        portal_company_name: company.attributes.portal_companies.find(portalCompany => portalCompany.portal_id === this.portal.id)?.name,
      }
    },

    store(company) {
      http.post('/api/v2/portal-companies', {
        portal_id: this.portal.id,
        company_id: company.id,
        name: company.name
      }).then(response => {
        this.$router.push('create/' + response.data.data.id)
      })
    }
  }
}
</script>
